import { Pipe, PipeTransform } from '@angular/core';
import * as jalalimoment from "jalali-moment";
@Pipe({
  name: 'shamsi'
})
export class ShamsiPipe implements PipeTransform {

  transform(value: Date): string {
    if(!value)return '';
    let date = new Date(value);
    
    return `${jalalimoment(date.toString()).locale('fa').format('YYYY/M/D')}`;
  }

}
